import { render } from "./product-wishlist.vue?vue&type=template&id=2335c305"
import script from "./product-wishlist.vue?vue&type=script&lang=js"
export * from "./product-wishlist.vue?vue&type=script&lang=js"

import exportComponent from "/buddy/stephen-webster/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__